import React from 'react'
import sthil from '../img/sthil.fw.png'
import mercado from '../img/mercado.fw.png'
import construcao from '../img/construcao.fw.png'
import '../css/home/homeSeguimento.css'

export const HomeSeguimento = () =>{

   return(
      
      <div className='row justify-content-center alinhar' style={{ display: 'flex', gap: '20px' }}>

         <span style={{color:'#2F4F4F', fontWeight:'bold'}}>Escolha o Seguimento: <br></br></span>
         <hr/>


                 <div className="card shadow p-2" style={{width:"18rem"}}>
                     <img
                        className="d-flex"
                        src={sthil}
                        alt="Seguimento Sthil"
                     />
                     <div className="card-body">
                     <h5 className="card-title">Sthil</h5>
                     <h6 className="card-subtitle mb-2 text-muted ">Representação completa de ferramentas com qualidade Stihl, para quem exige o melhor</h6>
                     </div>
                </div>

               
               <div className="card shadow p-2" style={{width:"18rem"}}>
                     <img
                        className="d-flex"
                        src={construcao}
                        alt="Seguimento Construcao"
                     />
      
                     <div className="card-body">
                     <h5 className="card-title">Mat. Construção</h5>
                     <h6 className="card-subtitle mb-2 text-muted ">As melhores marcas de produtos do Básico ao Acabamento</h6>
                     </div>
                </div>

               <div className="card shadow p-2" style={{width:"18rem"}}>
                     <img
                        className="d-flex"
                        src={mercado}
                        alt="Seguimento Mercado"
                     />
      
                     <div className="card-body">
                     <h5 className="card-title">Supermercados</h5>
                     <h6 className="card-subtitle mb-2 text-muted ">Linha Completa de Produtos Domésticos no Varejo e Atacado</h6>
                     </div>
                </div>
   
      
      </div>

   )
}